import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProviderLayout from '../../components/ProviderLayout';
import { apiFetch } from '../../api';


function money(v) {
  const n = Number(v);
  if (!v || Number.isNaN(n)) return "0 so'm";
  return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + " so'm";
}

export default function ProviderEarningsPage() {
  const { auth } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const hasData = !!stats && (Number(stats.completedTotal) > 0 || Number(stats.weekEarnings) > 0 || Number(stats.monthEarnings) > 0);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/provider/stats', auth.token);
      // 404 / bo'sh javob = hali daromad yo'q (nollar bilan bo'sh holat), xato emas.
      if (res.status === 404) {
        setStats(null);
        return;
      }
      if (!res.ok) throw new Error();
      const data = await res.json().catch(() => null);
      setStats(data && typeof data === 'object' ? data : null);
    } catch {
      setStats(null);
      setError('Daromad ma\'lumotini yuklashda xatolik yuz berdi.');
    } finally {
      setLoading(false);
    }
  }, [auth.token]);

  useEffect(() => { load(); }, [load]);

  return (
    <ProviderLayout title="Daromad">
      {loading ? (
        <div style={s.center}>Yuklanmoqda...</div>
      ) : error ? (
        <div style={s.error}>{error}</div>
      ) : (
        <>
          {!hasData && (
            <div style={s.empty}>
              <p style={s.emptyText}>Daromad hali yo'q</p>
              <p style={s.emptyHint}>Birinchi buyurtmani yakunlaganingizdan so'ng daromad shu yerda ko'rinadi.</p>
            </div>
          )}
          <div style={s.cardsRow}>
            <Card label="Shu hafta" value={money(stats?.weekEarnings)} />
            <Card label="Shu oy" value={money(stats?.monthEarnings)} />
          </div>

          <div style={s.block}>
            <div style={s.blockTitle}>Bajarilgan buyurtmalar</div>
            <Row label="Jami" value={stats?.completedTotal ?? 0} />
            <Row label="Shu hafta" value={stats?.completedWeek ?? 0} />
            <Row label="Shu oy" value={stats?.completedMonth ?? 0} />
            <Row label="O'rtacha reyting" value={Number(stats?.avgRating ?? 0).toFixed(1)} />
          </div>

          {Array.isArray(stats?.topServices) && stats.topServices.length > 0 && (
            <div style={s.block}>
              <div style={s.blockTitle}>Ommabop xizmatlar</div>
              {stats.topServices.map((t, i) => (
                <Row key={i} label={t.name || t.categoryName || `#${i + 1}`} value={t.count ?? t.ordersCount ?? ''} />
              ))}
            </div>
          )}
        </>
      )}
    </ProviderLayout>
  );
}

function Card({ label, value }) {
  return (
    <div style={s.card}>
      <div style={s.cardValue}>{value}</div>
      <div style={s.cardLabel}>{label}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={s.row}>
      <span style={s.rowLabel}>{label}</span>
      <span style={s.rowValue}>{value}</span>
    </div>
  );
}

const s = {
  center: { textAlign: 'center', padding: '48px', color: 'var(--color-text-muted)' },
  error: {
    background: 'var(--color-surface)',
    border: '1px solid var(--color-danger)',
    borderRadius: 'var(--radius-input)',
    padding: '12px 14px',
    color: 'var(--color-danger)',
    fontSize: '14px',
  },
  empty: { textAlign: 'center', padding: '16px 16px 24px' },
  emptyText: { margin: '0 0 4px', fontSize: '18px', fontWeight: '700', color: 'var(--color-text)' },
  emptyHint: { margin: 0, fontSize: '14px', color: 'var(--color-text-muted)' },
  cardsRow: { display: 'flex', gap: '8px', marginBottom: '16px' },
  card: {
    flex: 1,
    background: 'var(--color-surface-alt)',
    borderRadius: 'var(--radius-card)',
    padding: '16px',
    color: 'var(--color-text)',
  },
  cardValue: { fontSize: '20px', fontWeight: '700', lineHeight: 1.2 },
  cardLabel: { fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '6px' },
  block: {
    background: 'var(--color-surface-alt)',
    borderRadius: 'var(--radius-card)',
    padding: '16px',
    marginBottom: '8px',
  },
  blockTitle: { fontSize: '14px', fontWeight: '700', color: 'var(--color-text)', marginBottom: '10px' },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '9px 0',
    borderBottom: '1px solid var(--color-border)',
    fontSize: '14px',
  },
  rowLabel: { color: 'var(--color-text-muted)' },
  rowValue: { color: 'var(--color-text)', fontWeight: '600' },
};
